import React, {Component} from 'react';
import { Button, Input, Icon, Modal, Dimmer, Loader, Message, Label, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { generateLoginOTPPrefixEmail, verifyLoginOTPEmail2, resetLoginOTPEmail, filterClient, setRemindUpdatePassword, exportUserList } from '../../actions';
import { withRouter } from 'react-router';
import { Formik, Form, Field } from "formik";
import SysadminClientListExportTable from '../../component/sysadmin/client/list_client_export';

const memberOptions = [
    { key: 'a', text: 'All Members', value: 'all' },
    { key: 'e', text: 'Employees Only', value: 'e' },
    { key: 'd', text: 'Dependants Only', value: 'd' },
]

const filterOptions = [
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
    { key: 'name', text: 'Company Name', value: 'name' },
]
class ExportUser extends Component {
    state = {
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        isShowNextButton: true,
        isLoading: false,
        error: false,
        isSuccessMessageShow: false,
        errorMessage: null,
        memberType: 'all',
        query : '',
        filter: 'groupCode',
        downloading :false,
        isExportDisable: false,
        filteredData: [],
        isShowTable: false,
    };

    componentDidMount() {
        console.log("check component did mount", this.props.user)
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry. {this.state.errorMessage}</Message.Header>
                </Message>
            );
        }
    }

    exportSuccessfulMessage(){
        if (this.state.isSuccessMessageShow === true) {
            return (
                <Message positive>
                    <Message.Header>
                        Exporting user list....
                    </Message.Header>
                    <p>
                    We will send the file to your email once it's completed.
                </p>
                </Message>
            );
        }
    }

    onMemberDropdownChange = (e, { value }) => {
        this.setState({ memberType: value});
    }

    onChangePolicy = (e) => {
        this.setState({ policyNo: e.target.value })
    }

    onChangeGroupCode = (e) => {
        this.setState({ groupCode: e.target.value })
    }

    onFilterDropdownChange = (e, { value }) => {
        this.setState({ filter: value });
    }

    onSearchInput(e){
        if(e.target.value == ""){
            console.log("check is empty")
            this.setState({ filter: 'groupCode', query: '', isExportDisable : false});
        }
        else{
            this.setState({ query: e.target.value, isExportDisable : true })
        }
        
    }

    onClickExport = () => {
        const { accessToken } = this.props.user;
        this.setState({
                    downloading: true,
                    isSuccessMessageShow: false
                })
        this.props.exportUserList(this.state.filter, this.state.query, this.state.memberType, accessToken, 
            (result, error) => {
                    if(error){
                        this.setState({
                            error: true,
                            errorMessage : "Failed to download user list. Please try again later.",
                            downloading: false
                        })
                    }else{
                        this.setState({
                            downloading: false,
                            isSuccessMessageShow: true,
                            error: false,
                            errorMessage : null,
                        })
                    }
            })
    }

    getClients = (isFromSearch = false) => {
        const { accessToken } = this.props.user;

        this.setState({ isLoading: true, isSuccessMessageShow: false, error : false, errorMessage : null }, () => {
            this.props.filterClient({
                accessToken,
                searchPage: this.state.currentPage,
                searchMax: this.state.perPage,
                filtered: this.state.filter,
                typeQuery: this.state.query,
            }, (result, error) => {
                if(error){
                    if (error.errorCode === 401) {
                        console.log('Unauthorized or token expire.');
                        this.props.onCloseModal()
                        this.props.doLogout();
                        this.props.history.push('/');
                    }else{
                        this.setState({
                            isExportDisable : true,
                            filteredData : [],
                            error: true,
                            isShowTable: isFromSearch == true ? false : this.state.isShowTable,
                            errorMessage : "Failed to retrieve Client list. Please try again later.",
                        })
                    }
                    
                }else{
                    if(result.data.clients.length == 0){
                        this.setState({
                            isExportDisable : true,
                            filteredData : [],
                            isShowTable: isFromSearch == true ? true : this.state.isShowTable,
                            totalPage: result.data.pagination.totalPage,
                            totalData: result.data.pagination.totalData,
                            isLoading: false,
                        })
                    }else{
                        this.setState({
                            isExportDisable : false,
                            filteredData : result.data.clients,
                            isShowTable: isFromSearch == true ? true : this.state.isShowTable,
                            totalPage: result.data.pagination.totalPage,
                            totalData: result.data.pagination.totalData,
                            isLoading: false,

                        })
                        let countNext = this.state.perPage * this.state.currentPage
                        console.log("check countNext", countNext)
                        if(countNext < result.data.pagination.totalData){
                            this.setState({
                                isShowNextButton : true
                            })
                        }else{
                            this.setState({
                                isShowNextButton : false
                            })
                        }
                    }
                
                }
            })
        });
    }

    submitFilter = () => {
        this.setState({...this.state, currentPage: 1}, () => {
                this.setParams();
                this.getClients(true);
            });
    }

    clearFilter = () => {
        this.setState({ filter: 'groupCode', query: '' }, () => {
            this.props.history.push({
                search: `page=${this.state.currentPage}&v=${this.state.perPage}`
            })
            this.getClients();
        });
    }

    setParams = () => {
        let params = `page=${this.state.currentPage}&v=${this.state.perPage}`
        if (this.state.query !== '') {
            params = params + `&query=${this.state.query}`
        }
        this.props.history.push({
            search: params
        })
    }

    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.setParams();
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        if (this.state.filteredData.length >= this.state.perPage  ) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.setParams();
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.setParams();
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.setParams();
            this.getClients();
        });
    }
    
    render() {
        const loading = this.state.otpPrefix == "" ? true : false;
        return (
            <Modal
              open={!this.props.isVerified}
              size="small"
            >
                <Modal.Content>
                    <div style = {{display: 'flex', justifyContent: 'flex-end'}}>
                        <i className="close icon" onClick={this.props.onCloseModal}></i>
                    </div>
                    <div style = {{marginBottom:"20px", fontSize: "25px", marginLeft:"5px"}}>Export User</div>

                    <div style = {{width: "90%", display: "flex", marginBottom:"15px", marginLeft:"5px"}}>
                        <div style = {{width: "100%", float:"left", minHeight: "auto !important" , height:"30px"}}>
                            <Dropdown style = {{width: "100%"}} placeholder='Member Type' value={this.state.memberType}  selection options={memberOptions} onChange={this.onMemberDropdownChange}/>
                        </div>
                    </div>

                    <div style = {{width: "100%", display: "flex"}}>
                        <div style = {{width: "90%", float:"left", height:"30px", marginLeft:"5px", marginBottom:"15px"}}>
                            <Input fluid type='text' placeholder='Search...' action>
                                <input  value={this.state.query} onChange={this.onSearchInput.bind(this)} />
                                <Dropdown placeholder='Filter by' selection options={filterOptions}
                                    value={this.state.filter} onChange={this.onFilterDropdownChange}/>
                                <Button type="submit"  color="green" icon="search" content="Search" onClick={this.submitFilter}/>
                                { this.state.query.length > 0 &&
                                    <Button type="button" color="black" icon="close" content="Clear" onClick={this.clearFilter}/>
                                }
                            </Input>

                        </div>
                    </div>
                    {this.state.isShowTable &&
                        <div style = {{width: "90%", display: "flex", marginLeft:"5px", marginBottom:"5px"}}>
                            <SysadminClientListExportTable
                                clients={this.state.filteredData}
                                isLoading={this.state.isLoading}
                                isShowNextButton = {this.state.isShowNextButton}
                                users={this.props.users}
                                currentPage={this.state.currentPage}
                                perPage={this.state.perPage}
                                totalPage={this.state.totalPage}
                                totalData={this.state.totalData}
                                setPage={(num) => this.setPage(num)}
                                setPerPage={(num) => this.setPerPage(num)}
                                goToPreviousPage={() => this.goToPreviousPage()}
                                goToNextPage={() => this.goToNextPage()}
                            />
                        </div>
                    }
                    
                    
                    <div style = {{width: "90%", display: 'flex', justifyContent: 'flex-end', marginLeft:"10px"}}>
                        <div style = {{height:"40px", fontSize : "16px", float: 'right'}}>
                            <Button onClick={this.onClickExport} color="blue" content="Export User" disabled = {this.state.isExportDisable} loading={this.state.downloading}/>
                        </div>
                    </div>
                    <div style = {{width: "100%", display: "flex"}}>
                        <div style = {{width: "90%", fontSize : "16px", margin:"5px"}}>
                        {this.renderFormSubmissionResult()}
                        {this.exportSuccessfulMessage()}
                        </div>
                    </div>
                    
                </Modal.Content>
            </Modal>
          )
    }
}
function mapStateToProps(state) {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
    };
}
 
export default withRouter(connect(mapStateToProps, {exportUserList, filterClient})(ExportUser));
